import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var API_URL = 'assets/data.json';
var LARGE_DATASET_API_URL = 'assets/large.json';
var AppService = /** @class */ (function () {
    function AppService(http) {
        this.http = http;
    }
    AppService.prototype.getSingleSelectOptions = function () {
        return this.http.get(API_URL).pipe(map(function (d) { return d.singleSelectOptions; }));
    };
    AppService.prototype.getMultipleSelectOptions = function () {
        return this.http.get(API_URL).pipe(map(function (d) { return d.multipleSelectOptions; }));
    };
    AppService.prototype.getGroupingOptions = function () {
        return this.http.get(API_URL).pipe(map(function (d) { return d.groupingOptions; }));
    };
    AppService.prototype.getObservableOptions = function () {
        return this.http.get(API_URL).pipe(map(function (d) { return d.observableOptions; }));
    };
    AppService.prototype.getPersons = function () {
        return this.http.get(API_URL).pipe(map(function (d) { return d.persons; }));
    };
    AppService.prototype.getLargeDataset = function () {
        return this.http.get(LARGE_DATASET_API_URL);
    };
    AppService.ngInjectableDef = i0.defineInjectable({ factory: function AppService_Factory() { return new AppService(i0.inject(i1.HttpClient)); }, token: AppService, providedIn: "root" });
    return AppService;
}());
export { AppService };
